import { render, staticRenderFns } from "./RelatedGuideCard.vue?vue&type=template&id=203c472e"
import script from "./RelatedGuideCard.vue?vue&type=script&lang=js"
export * from "./RelatedGuideCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports